import {gql} from 'shared/__generated__';

export const PERMISSIONS = gql(`
query UnavailableCompanyPermissions($companyId: String!) {
  ...Permissions
}`);
